import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TokenService } from '../services/token.service';
import { LanguageService } from '@core/services/language.service';
import { switchMap, take } from 'rxjs';

export const languageInterceptor: HttpInterceptorFn = (req, next) => {
    return inject(LanguageService).currentLang$.pipe(
      take(1),
      switchMap(language => {
          const request = req.clone({
              setHeaders: {
                  ...(language ? { 'Accept-Language': language?.code } : {}),
              },
          });

          return next(request);
      })
  )
};
